import { IConversationList } from "Common/Interfaces";
import { DEFAULT_CONVERSATION_PAGE_SIZE } from "./../Constants";

// Returns a new conversation list with the renamed conversation applied.
// Returns null when there is no list, or no conversation matching the given id.
export const applyConversationTitle = (
  conversationList: IConversationList | undefined,
  conversationId: string,
  newTitle: string
): IConversationList | null => {
  const conversations = conversationList?.conversations;
  const conversationToUpdate = conversations?.find((c) => c.conversationId === conversationId);

  if (!conversationList || !conversationToUpdate) {
    return null;
  }

  return {
    ...conversationList,
    conversations:
      conversations?.map((c) => (c.conversationId === conversationId ? { ...c, title: newTitle } : c)) ?? [],
    // Fallback values in case `pageSize` / `continuationToken` are undefined
    pageSize: conversationList.pageSize || DEFAULT_CONVERSATION_PAGE_SIZE,
    continuationToken: conversationList.continuationToken || null,
  };
};
